import { campaignTypes } from "@campaign/campaign-types.di";
import type {
    Campaign,
    CampaignUpdate,
} from "@campaign/domain/models/campaign.model";
import type { CampaignRepository } from "@campaign/domain/repositories/campaign.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import { RecuperableModelError } from "@iot-platform/core";
import { inject, injectable } from "inversify";

@injectable()
export class CampaignUpdateUseCase {
    constructor(
        @inject(campaignTypes.repositories.CampaignRepository)
        private readonly campaignRepository: CampaignRepository,
    ) {}

    async execute(
        campaignId: string,
        campaign: CampaignUpdate,
    ): Promise<Nullable<Campaign>> {
        const editResult = await this.campaignRepository.update(
            campaignId,
            campaign,
        );

        return editResult.match(
            (campaignEdited) => campaignEdited,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
